"use strict";
// generate UTM source based on the current subdomain
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUtmSource = void 0;
const web_env_1 = require("@snapchat/web-env");
// e.g. accounts.snapchat.com -> accounts_snapchat_com
const generateUtmSource = () => {
    const domain = (0, web_env_1.getWindow)()?.location.hostname;
    return domain?.replace(/\./g, "_") || "www_snapchat_com";
};
exports.generateUtmSource = generateUtmSource;
//# sourceMappingURL=urls.js.map